import { faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { HTMLAttributes, ReactNode, forwardRef } from "react";

import styles from "./collapsible.module.css";

const DefaultExpandedIcon = <FontAwesomeIcon icon={faAngleDown} />;

const DefaultCollapsedItem = <FontAwesomeIcon icon={faAngleRight} />;

type Props = {
    isCollapsibleExpanded: boolean;
    expandedIcon?: ReactNode;
    collapsedIcon?: ReactNode;
} & HTMLAttributes<HTMLSpanElement>;

const CollapsibleIndicator = forwardRef<HTMLSpanElement, Props>((props, ref) => {
    const {
        isCollapsibleExpanded,
        expandedIcon = DefaultExpandedIcon,
        collapsedIcon = DefaultCollapsedItem,
        className,
        ...rest
    } = props;

    const icon = isCollapsibleExpanded ? expandedIcon : collapsedIcon;

    return (
        <span {...rest} className={clsx(className, styles.collapsible_indicator)} ref={ref}>
            {icon}
        </span>
    );
});

CollapsibleIndicator.displayName = "Indicator";

export { CollapsibleIndicator };
export type { Props as IndicatorProps };
